import script from "./agent-practice.vue?vue&type=script&setup=true&lang=js"
export * from "./agent-practice.vue?vue&type=script&setup=true&lang=js"

import "./agent-practice.vue?vue&type=style&index=0&id=4cd64554&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd64554"]])

export default __exports__